import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { redirectToAuth } from '@/lib/oidc';

function currentReturnTo(location: { pathname: string; search: string; hash: string }) {
    return `${location.pathname}${location.search}${location.hash}`;
}

/** Leave the current URL and open the sign-in page, then return here. */
export function RedirectToAuth() {
    const location = useLocation();
    useEffect(() => {
        redirectToAuth(currentReturnTo(location));
    }, [location.pathname, location.search, location.hash]);
    return null;
}

/** Hold private pages until the OIDC session is known, then sign in with a return path. */
export function RequireAuth({ children }: { children: ReactNode }) {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            redirectToAuth(currentReturnTo(location));
        }
    }, [loading, isAuthenticated, location.pathname, location.search, location.hash]);

    if (loading || !isAuthenticated) return null;
    return children;
}
